import { Column } from '@app/modules/table/classes/column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';

export class TypeColumn extends Column {
    title = 'payroll.benefits.type';
    property = 'benefitTypeDisplayName';
    type: CellDisplay = CellDisplay.string;
}
